import { type Job, type JobCreateInput } from "@vidario/domain";
import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";

import { useVidarioClient } from "../client";
import { queryKeys } from "../queryKeys";

export interface UpdateJobInput {
  id: string;
  input: JobCreateInput;
}

/** PATCH /jobs/:id — saves the job's editable fields. Never changes its
 * status; sending a draft goes through `useSendJob`. */
export function useUpdateJob(): UseMutationResult<Job, Error, UpdateJobInput> {
  const client = useVidarioClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }) => client.updateJob(id, input),
    onSuccess: (job) => {
      qc.invalidateQueries({ queryKey: ["jobs"] });
      qc.setQueryData(queryKeys.job(job.id), job);
    },
  });
}
